/**
 * Static config for the `jlt-core/pricing-bundle` block.
 *
 * Deliberately a plain module with no "use client": the SERVER BlockRenderer reads
 * each tab's `button` payload and encrypts it into a checkout query. This used to
 * live inline in BundlePricing.js — a client component — which is why the AES key
 * had to be NEXT_PUBLIC_ and therefore public. See utils/hashData.js.
 */
export const bundlePricingAttributes = {
    borders: { color: "#e2e8f0", style: "solid", width: "1px" },
    borderRadius: { top: "0px", left: "0px", right: "8px", bottom: "8px" },
    offerStyle: {
      background: "#16213e",
      color: "#fff",
      borderRadius: { top: "4px", left: "0px", right: "4px", bottom: "0px" },
      position: "top", // top | left | right
      positionY: -30,
      positionX: 0,
    },
    buttonStyle: {
      position: "top",
    },
    featureButtonStyle: {
      color: "black",
      hoverColor: "var(--primary)",
    },
    tabs: [
      {
        tabTitle: "200",
        title: "Lifetime Bundle",
        subtitle: "Perfect for Enterprise solution",
        // normalPrice: "$1199.00",
        price: "599.00",
        savePrice: "(TAX Included)",
        duration: "Lifetime",
        offerText: "WP Adminify Bundle",
        button: {
          btnText: "Checkout",
          paddleProductIds: [
            {
              product_id: "32600",
              variation_id: "32687",
              price_id: "pri_01jrz53mhz4d6ejm0164zehgp0",
            },
          ],
          couponCode: "bundle20",
          bundle: true,
          bundleProductsIds: [
            {
              price_id: "pri_01jrz0z1pr6kh2620tj1nvz7dp",
              product_id: "30532",
              variation_id: "32668",
            },
          ],
          freemiusProducts: [
            {
              name: "WP Adminify Bundle",
              product_id: "18365",
              plan_id: "30431",
              pricing_id: "39150",
              login_url: "https://users.freemius.com/login",
              logo_url: "https://freemius.com/favicon.ico",
            },
          ],
          btnColor: "#ffffff",
          btnBgColor: "#000000",
          border: { color: "#3a3ae9", width: "2px" },
          borderRadius: "5",
          width: "100%",
          lists: ["3"],
          tags: ["128", " 127"],
          proTags: ["136"],
          page_content: "",
        },
        features: [
          { label: "Use on up to 200 Websites", active: true },
          { label: "Lifetime Updates and Support", active: true },
          {
            label: "WP Adminify",
            active: true,
            icon: "/product-icon/wp-adminify.png",
            link: "https://wpadminify.com",
          },
          {
            label: "Loginfy",
            active: true,
            icon: "/product-icon/loginfy.svg",
            link: "https://wpadminify.com/loginfy",
          },
          {
            label: "WP Spotlight",
            active: true,
            icon: "/product-icon/wp-spotlight.svg",
            link: "https://wpspotlight.pro",
          },
          {
            label: "Header and Footer Scripts",
            active: true,
            icon: "/product-icon/header-footer-script.svg",
            link: "https://wpadminify.com/header-footer-scripts",
          },
          {
            label: "Quick Menu",
            active: true,
            icon: "/product-icon/quick-menu.svg",
            link: "https://wpadminify.com/quick-menu",
          },
          {
            label: "Admin Bar Editor",
            active: false,
            icon: "/product-icon/admin-bar.webp",
            link: "https://jeweltheme.com/admin-bar-editor",
          },
          {
            label: "Admin Columns Editor",
            active: false,
            icon: "/product-icon/admin-column.webp",
            link: "https://wpadminify.com/admin-columns-editor",
          },
        ],
        // featureBtnText: "See more",
        // featureBtnURL: { link: "https://wpadminify.com/features", target: "_blank" },
      },
      {
        tabTitle: "500",
        title: "Lifetime Bundle",
        subtitle: "Perfect for Enterprise solution",
        // normalPrice: "$1499.00",
        price: "749.00",
        savePrice: "(TAX Included)",
        duration: "Lifetime",
        offerText: "WP Adminify Bundle",
        button: {
          btnText: "Checkout",
          paddleProductIds: [
            {
              product_id: "32600",
              variation_id: "32602",
              price_id: "pri_01jqxp9fz5a41jk2117kvmaen3",
            },
          ],
          couponCode: "bundle20",
          bundle: true,
          bundleProductsIds: [
            {
              price_id: "pri_01jrz10wj9an80cbswts3f1xy5",
              product_id: "30532",
              variation_id: "32669",
            },
            {
              price_id: "pri_01jrz0gwm4vwsefmpazpn08ase",
              product_id: "26716",
              variation_id: "32666",
            },
          ],
          freemiusProducts: [
            {
              name: "WP Adminify Bundle",
              product_id: "18365",
              plan_id: "30430",
              pricing_id: "39152",
              login_url: "https://users.freemius.com/login",
              logo_url: "https://freemius.com/favicon.ico",
            },
          ],
          btnColor: "#ffffff",
          btnBgColor: "#000000",
          border: { color: "#3a3ae9", width: "2px" },
          borderRadius: "5",
          width: "100%",
          lists: ["3"],
          tags: ["128", " 127"],
          proTags: ["136"],
          page_content: "",
        },
        features: [
          { label: "Use on up to 500 Websites", active: true },
          { label: "Lifetime Updates and Support", active: true },
          {
            label: "WP Adminify",
            active: true,
            icon: "/product-icon/wp-adminify.png",
            link: "https://wpadminify.com",
          },
          {
            label: "Loginfy",
            active: true,
            icon: "/product-icon/loginfy.svg",
            link: "https://wpadminify.com/loginfy",
          },
          {
            label: "WP Spotlight",
            active: true,
            icon: "/product-icon/wp-spotlight.svg",
            link: "https://wpspotlight.pro",
          },
          {
            label: "Header and Footer Scripts",
            active: true,
            icon: "/product-icon/header-footer-script.svg",
            link: "https://wpadminify.com/header-footer-scripts",
          },
          {
            label: "Quick Menu",
            active: true,
            icon: "/product-icon/quick-menu.svg",
            link: "https://wpadminify.com/quick-menu",
          },
          {
            label: "Admin Bar Editor",
            active: true,
            icon: "/product-icon/admin-bar.webp",
            link: "https://jeweltheme.com/admin-bar-editor",
          },
          {
            label: "Admin Columns Editor",
            active: true,
            icon: "/product-icon/admin-column.webp",
            link: "https://wpadminify.com/admin-columns-editor",
          },
        ],
        // featureBtnText: "See more",
        // featureBtnURL: { link: "https://wpadminify.com/features", target: "_blank" },
      },
      {
        tabTitle: "Unlimited",
        title: "Lifetime Bundle",
        subtitle: "Perfect for Enterprise solution",
        // normalPrice: "$4999.00",
        price: "799.00",
        savePrice: "(TAX Included)",
        duration: "Lifetime",
        offerText: "WP Adminify Bundle",
        button: {
          btnText: "Checkout",
          paddleProductIds: [
            {
              product_id: "32600",
              variation_id: "32603",
              price_id: "pri_01jqxp9g3q3n3kej8e26gm9d84",
            },
          ],
          couponCode: "bundle20",
          bundle: true,
          bundleProductsIds: [
            {
              price_id: "pri_01jrz128g7bpge25jx9v23ktmf",
              product_id: "30532",
              variation_id: "32670",
            },
            {
              price_id: "pri_01jrz0pbejkjp831f125fcq159",
              product_id: "26716",
              variation_id: "32667",
            },
          ],
          freemiusProducts: [
            {
              name: "WP Adminify Bundle",
              product_id: "18365",
              plan_id: "30947",
              pricing_id: "59181",
              login_url: "https://users.freemius.com/login",
              logo_url: "https://freemius.com/favicon.ico",
            },
          ],
          btnColor: "#ffffff",
          btnBgColor: "#000000",
          border: { color: "#3a3ae9", width: "2px" },
          borderRadius: "5",
          width: "100%",
          lists: ["3"],
          tags: ["128", " 127"],
          proTags: ["136"],
          page_content: "",
        },
        features: [
          { label: "Use on up to Unlimited Websites", active: true },
          { label: "Lifetime Updates and Support", active: true },
          {
            label: "WP Adminify",
            active: true,
            icon: "/product-icon/wp-adminify.png",
            link: "https://wpadminify.com",
          },
          {
            label: "Loginfy",
            active: true,
            icon: "/product-icon/loginfy.svg",
            link: "https://wpadminify.com/loginfy",
          },
          {
            label: "WP Spotlight",
            active: true,
            icon: "/product-icon/wp-spotlight.svg",
            link: "https://wpspotlight.pro",
          },
          {
            label: "Header and Footer Scripts",
            active: true,
            icon: "/product-icon/header-footer-script.svg",
            link: "https://wpadminify.com/header-footer-scripts",
          },
          {
            label: "Quick Menu",
            active: true,
            icon: "/product-icon/quick-menu.svg",
            link: "https://wpadminify.com/quick-menu",
          },
          {
            label: "Admin Bar Editor",
            active: true,
            icon: "/product-icon/admin-bar.webp",
            link: "https://jeweltheme.com/admin-bar-editor",
          },
          {
            label: "Admin Columns Editor",
            active: true,
            icon: "/product-icon/admin-column.webp",
            link: "https://wpadminify.com/admin-columns-editor",
          },
        ],
        // featureBtnText: "See more",
        // featureBtnURL: { link: "https://wpadminify.com/features", target: "_blank" },
      },
      // {
      //   tabTitle: "Unlimited Test",
      //   title: "Lifetime Bundle Test",
      //   subtitle: "This is test bundle",
      //   // normalPrice: "$4999.00",
      //   price: "100.00",
      //   savePrice: "(TAX Included)",
      //   duration: "Lifetime",
      //   offerText: "Pixarlabs Unlimited Test",
      //   button: {
      //     btnText: "Checkout Test",
      //     paddleProductIds: [
      //       {
      //         product_id: "31825",
      //         variation_id: "31827",
      //         price_id: "pri_01jp4vf4d55zhgpv5znj8ecgwt",
      //       },
      //     ],
      //     // couponCode: "bundle20",
      //     bundle: true,
      //     bundleProductsIds: [
      //       {
      //         // WP Spotlight Local
      //         price_id: "pri_01jp6y4m8n2xw640gf63fjj67v",
      //         product_id: "31839",
      //         variation_id: "31841",
      //       },
      //       {
      //         // Admin Bar Local
      //         price_id: "pri_01jp6xhe9ez7gnwdvxm2x5y0p1",
      //         product_id: "31835",
      //         variation_id: "31837",
      //       },
      //     ],
      //     freemiusProducts: [
      //       {
      //         name: "Pixarlabs Bundle",
      //         product_id: "18340",
      //         plan_id: "45390",
      //         pricing_id: "59277",
      //         login_url: "https://users.freemius.com/login",
      //         logo_url: "https://freemius.com/favicon.ico",
      //       },
      //     ],
      //     btnColor: "#ffffff",
      //     btnBgColor: "#000000",
      //     border: { color: "#3a3ae9", width: "2px" },
      //     borderRadius: "5",
      //     width: "100%",
      //     lists: ["3"],
      //     tags: ["128", " 127"],
      //     proTags: ["136"],
      //     page_content: "",
      //   },
      //   features: [
      //     { label: "Use on up to Unlimited Websites", active: true },
      //     { label: "Lifetime Updates and Support", active: true },
      //     {
      //       label: "WP Adminify",
      //       active: true,
      //       icon: "/product-icon/wp-adminify.png",
      //       link: "https://wpadminify.com",
      //     },
      //     {
      //       label: "Loginfy",
      //       active: true,
      //       icon: "/product-icon/loginfy.svg",
      //       link: "https://wpadminify.com/loginfy",
      //     },
      //     {
      //       label: "WP Spotlight",
      //       active: true,
      //       icon: "/product-icon/wp-spotlight.svg",
      //       link: "https://wpspotlight.pro",
      //     },
      //     {
      //       label: "Header and Footer Scripts",
      //       active: true,
      //       icon: "/product-icon/header-footer-script.svg",
      //       link: "https://wpadminify.com/header-footer-scripts",
      //     },
      //     {
      //       label: "Quick Menu",
      //       active: true,
      //       icon: "/product-icon/quick-menu.svg",
      //       link: "https://wpadminify.com/quick-menu",
      //     },
      //     {
      //       label: "Admin Bar Editor",
      //       active: true,
      //       icon: "/product-icon/admin-bar.webp",
      //       link: "https://jeweltheme.com/admin-bar-editor",
      //     },
      //     {
      //       label: "Admin Columns Editor",
      //       active: true,
      //       icon: "/product-icon/admin-column.webp",
      //       link: "https://wpadminify.com/admin-columns-editor",
      //     },
      //   ],
      //   // featureBtnText: "See more",
      //   // featureBtnURL: { link: "https://wpadminify.com/features", target: "_blank" },
      // },
    ],
};
